export function generateRandomId(length: number = 8): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

/**
 * 解析cookie
 * @param key - cookie 的键名
 * @return cookie 值或 cookie 对象
 */
export function getCookie(key?: string): string | Record<string, string> {
  const cookieStr = window.document ? document.cookie : '';
  const cookieAry = cookieStr.split(/\s?;\s?/);
  const cookieMap: Record<string, string> = {};
  cookieAry.forEach(function (x) {
    const i = x.indexOf('=');
    if (i >= 0) {
      cookieMap[x.substring(0, i)] = x.substring(i + 1);
    }
  });
  return key ? cookieMap[key] : cookieMap;
}

export const generateUUID = (): string => {
  var d = new Date().getTime(); //Timestamp
  var d2 = (performance && performance.now ? (performance.now() * 1000) :  0) || 0 ; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) { //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else { //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    // eslint-disable-next-line no-mixed-operators
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

interface UserInfo {
  [key: string]: any;
}

export const getUserInfo = (): UserInfo => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') as UserInfo;
  return userInfo;
};

// 生成UUID   by panhuaguo  20191204
export const getUUID = (len?: number, radix?: number): string => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid: string[] = [];
  let i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}; 

// 根据 value 获取 对应的项 的工具函数
export const getItemByValue = (value: string, dataSource: any[] = []): any => {
  const findItem = (items: any[]): any => {
    for (const item of items) {
      if (item.value === value) {
        return item;
      }
      if (item.children && item.children.length > 0) {
        const found = findItem(item.children);
        if (found) return found;
      }
    }
    return null;
  };
  return findItem(dataSource);
};

// 根据 value 获取 label 的工具函数
export const getLabelByValue = (value: string, dataSource: any[] = []): string => {
  const findLabel = (items: any[]): string => {
    for (const item of items) {
      if (item.value === value) {
        return item.label;
      }
      if (item.children && item.children.length > 0) {
        const found = findLabel(item.children);
        if (found) return found;
      }
    }
    return '';
  };
  return findLabel(dataSource);
};

// 根据多个 value 获取对应的 label 数组
export const getLabelsByValues = (values: string[], dataSource: any[] = []): string[] => {
  return values.map(value => getLabelByValue(value, dataSource));
};

// URL参数解析工具函数
export const parseUrlParams = (search: string = window.location.search) => {
  const params = new URLSearchParams(search);
  let result: Record<string, string> = {};
  
  for (const [key, value] of params.entries()) {
    if (key === 'robotShow' && value.includes('*')) {
      // 解析钉钉链接跳转带过来的特殊参数
      const dingTalkParams = parseDingTalkParams(`${key}=${value}`);
      result = {
        ...result,
        ...dingTalkParams,
      };
    } else {
      result[key] = value;
    }
  }
  
  return result;
};

/**
 * 解析钉钉链接跳转带过来的参数工具函数
 * 解析格式如: "robotShow=true*subscriptionId=8*scheduledTaskId=947"
 * 注：之所以要用*拼接，是因为重新登录后，URL参数除第一个外，其他都会丢失，所以需要用*拼接
 * @param paramString - 要解析的参数字符串
 * @returns 解析后的参数对象
 */
export const parseDingTalkParams = (paramString?: string): Record<string, string> => {
  if (!paramString || typeof paramString !== 'string') {
    return {};
  }

  const result: Record<string, string> = {};
  
  // 按星号分割参数
  const pairs = paramString.split('*');
  
  pairs.forEach(pair => {
    // 按等号分割键值对
    const [key, value] = pair.split('=');
    
    if (key && value && value !== 'undefined' && value !== '' && value !== 'null') {
      const trimmedKey = key.trim();
      const trimmedValue = value.trim();
      result[trimmedKey] = trimmedValue;
    }
  });
  
  return result;
};

/**
 * UTF-8安全的解码器类
 */
export class UTF8SafeDecoder {
  private decoder: TextDecoder;
  private buffer: Uint8Array;

  constructor() {
    this.decoder = new TextDecoder('utf-8');
    this.buffer = new Uint8Array(0);
  }

  // 添加新的字节数据并尝试解码
  addBytes(newBytes: Uint8Array): string {
    // 合并缓冲区
    const combined = new Uint8Array(this.buffer.length + newBytes.length);
    combined.set(this.buffer);
    combined.set(newBytes, this.buffer.length);

    // 尝试解码，保留可能不完整的字符
    let decodedStr = '';
    let remainingBytes = new Uint8Array(0);

    try {
      // 使用 stream: true 允许不完整的字符
      decodedStr = this.decoder.decode(combined, { stream: true });
    } catch (e) {
      // 如果解码失败，尝试找到最后一个完整字符的位置
      const lastValidPos = this.findLastValidCharPosition(combined);
      
      if (lastValidPos > 0) {
        try {
          decodedStr = this.decoder.decode(combined.slice(0, lastValidPos), { stream: false });
          remainingBytes = combined.slice(lastValidPos);
        } catch (e2) {
          console.warn('部分解码失败，保留所有字节：', e2);
          remainingBytes = combined;
        }
      } else {
        remainingBytes = combined;
      }
    }

    // 更新缓冲区
    this.buffer = remainingBytes;
    return decodedStr;
  }

  // 完成解码，处理剩余的字节
  finalize(): string {
    if (this.buffer.length === 0) {
      return '';
    }

    try {
      const finalStr = this.decoder.decode(this.buffer, { stream: false });
      this.buffer = new Uint8Array(0);
      return finalStr;
    } catch (e) {
      console.warn('最终解码失败：', e);
      this.buffer = new Uint8Array(0);
      return '';
    }
  }

  // 找到最后一个完整UTF-8字符的位置
  private findLastValidCharPosition(bytes: Uint8Array): number {
    for (let i = bytes.length - 1; i >= 0; i--) {
      const byte = bytes[i];
      // UTF-8字符的第一个字节不会以10开头（10xxxxxx是后续字节）
      if ((byte & 0xC0) !== 0x80) {
        return i;
      }
    }
    return 0;
  }
}

// 去除百分号、￥、,、元等符号，转数字，超万转"万"单位
export const formatValueToWan = (val: any) => {
  if (typeof val === 'string') {
    // 去除 %, ￥, 元, 逗号等
    const numStr = val.replace(/[%￥,元\s]/g, '');
    const num = parseFloat(numStr);
    if (isNaN(num)) return val; // 不是数字，原样返回
    if (val.includes('%')) return num; // 百分比只去符号，不转万
    if (num >= 10000) return (num / 10000).toFixed(2) + '万';
    return num;
  }
  if (typeof val === 'number') {
    if (val >= 10000) return (val / 10000).toFixed(2) + '万';
    return val;
  }
  return val;
}
